import "./podcastGuest2.css";

import React from "react";

export default function PodcastGuest2Card({
  image,
  guestDescription,
  guestFullName,
}) {
  return (
    <div className="cardNew">
      {/* Guest Image */}
      <img
        src={image}
        alt="Guest"
        className="guest-image"
        crossOrigin="anonymous"
      />

      {/* Overlay */}
      <img
        src="https://res.cloudinary.com/bsgfcooa/image/upload/v1785214558/3-guest-quote-carousel-WED_2_fvid3s.png"
        alt="Template"
        className="overlay-image"
        crossOrigin="anonymous"
      />

      <div className="content">
        <p className="description">{guestDescription}</p>
      </div>

      <div className="guest-name-new">{guestFullName}</div>
    </div>
  );
}
